export default (passengerId: string) => passengerId.split('-')[0]
